import { useMutation } from '@common-fe/common-fe';

import { api } from '@/api';
import { API_URL } from '@/dtos';
import type { IPropagateOverridablePropertiesResponse } from '@/dtos/models/IPropagateOverridablePropertiesResponse';
import type { IPropertyChangeDto } from '@/dtos/models/IPropertyChangeDto';

interface Params {
  organizationId: string;
  properties: IPropertyChangeDto[];
}

export const usePropagateOverridablePropertiesQuery = () => {
  const { mutateAsync, isPending } = useMutation(({ organizationId, properties }: Params) =>
    api.post<IPropagateOverridablePropertiesResponse>(
      API_URL.ORGANIZATIONS_OVERRIDABLE_PROPERTIES_PROPAGATE_BY_ORGANIZATION_ID(organizationId),
      { properties }
    )
  );

  return {
    propagateOverridableProperties: mutateAsync,
    isLoading: isPending,
  };
};
